import { isServer } from '@respond-framework/utils';
import { scrollElementIntoView } from '../utilities/scroll';
import { animateHashScrollKinds } from './animateHashScrollKinds';

export const scrollToHash = () => (request, next) =>
  next()
    /**
     * Chain after the rest of the middleware pipeline has completed.
     * This means scrolling to hash happens after the URL changes and
     * the new page is rendered.
     */
    .then(() => {
      /**
       * Destructure the request now, because `action.location` is not
       * available initially
       */
      const {
        action: {
          hash,
          location: { kind },
        },
      } = request;
      /**
       * Don't scroll to the hash when using the browser back/next buttons
       * because that is handled by the scroll restoration middleware.
       * Initial page load would be handled automatically if there was SSR
       */
      if (isServer() || !animateHashScrollKinds.includes(kind)) {
        return;
      }
      if (hash) {
        const element = document.getElementById(hash);
        if (element) {
          scrollElementIntoView(element, {
            behavior: 'smooth',
            block: 'center',
          });
        }
      }
    });
